import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { QcDashboardPageComponent } from "./qc-dashboard-page/qc-dashboard-page.component";
import { FormsModule } from "@angular/forms";
import { FreshnessChartComponent } from "./freshness-chart/freshness-chart.component";
import { ChartPlotterModule } from "src/app/chart-plotter/chart-plotter.module";
import { Routes, RouterModule } from "@angular/router";
import { ConsensusTemplateComponent } from "./consensus-template/consensus-template.component";
import { SharedModule } from "../shared/shared.module";
import { IconsModule } from "@va/core-library/icons";
import { NzSkeletonModule } from "ng-zorro-antd/skeleton";
import { NzTableModule } from "ng-zorro-antd/table";
import { NzGridModule } from "ng-zorro-antd/grid";

import { ForecastChartComponent } from "./forecast-chart/forecast-chart.component";
import { ConsensusBarComponent } from "./consensus-bar/consensus-bar.component";
import { NotesSectionComponent } from "./notes-section/notes-section.component";
import { NzButtonModule } from "ng-zorro-antd/button";
import { NzSelectModule } from "ng-zorro-antd/select";
import { NzSwitchModule } from "ng-zorro-antd/switch";
const qcRoutes: Routes = [
  {
    path: "",
    pathMatch: "full",
    component: QcDashboardPageComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(qcRoutes)],
  exports: [RouterModule],
})
export class QcDashboardRoutingModule {}

@NgModule({
  declarations: [
    QcDashboardPageComponent,
    ConsensusTemplateComponent,
    FreshnessChartComponent,
    ForecastChartComponent,
    ConsensusBarComponent,
    NotesSectionComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    IconsModule,
    NzSkeletonModule,
    NzTableModule,
    NzButtonModule,
    NzSelectModule,
    NzGridModule,
    NzSwitchModule,

    QcDashboardRoutingModule,
    ChartPlotterModule,
    FormsModule,
  ],
})
export class QcDashboardPageModule {}
